module.exports = __webpack_public_path__ + "img/4352a60.jpg";